<template>
  <div class="page-container" style="scroll-behavior: smooth;">
    <div>
      <b-modal id="my-modal" centered hide-footer :no-close-on-backdrop="true" title="Cookie policy">
        <p class="text-modal">Diese Website verwendet Cookies und Analysewerkzeuge. Wir gehen davon aus, dass dies für Sie in Ordnung ist, aber Sie können die Verwendung von Cookies jederzeit ablehnen, wenn Sie dies wünschen. Hiernach wird jedoch die Nutzung der Webseite verwehrt.</p>
        <p class="text-modal">Sie können Ihre Einstellungen für Google Analytics und Cookies auf Seite Datenschutz aktualisieren.</p>

        <b-button class="mt-3" variant="success" block @click="acceptCookies">Akzeptieren</b-button>
      </b-modal>
    </div>
    <div class="row page-paddings-left">
      <div class="col-6 align-middle cc-intro">

        <b-row>
          <h1 class="entry-tittle-main">Wie viel kostet eine App? </h1>
        </b-row>
        <b-row>
          <p class="text-white pt-4 pb-4">Wir werden immer öfters gefragt, wieviel es kostet, eine App zu erstellen. Wie Sie richtig vermuten, hängt dies von vielen unterschiedlichen Faktoren ab. Dieser App-Rechner soll Ihnen eine Preisvorstellung vermitteln. Die tatsächlichen Preise können jedoch nach unten bzw. nach oben variieren. Viel Spaß beim ersten Schritt zu Ihrer eigenen App.</p>
        </b-row>
        <b-row>
          <b-button href="#cost" class="cc-button">Preis herausfinden</b-button>
        </b-row>
      </div>
      <div class="col-6">
        <img class="w-100" src="../assets/Mainpic.png">
      </div>



    </div>
    <b-row class="cc-point-title-container mt-2">
      <b-col class="col-2 pt-1"><img src="../assets/line.png"></b-col>
      <b-col class="col-lg-5"><h3  id="cost" class="cc-point-title">Schritt 1 - Allgemeine Informationen</h3></b-col>
    </b-row>
    <div class="page-paddings">
      <div class="cc-questions-container">

        <div class="point-container">
          <div class="row">
            <p class="point-number">1. </p>
            <p class="point-name">App-Format?</p>
          </div>

          <div class="col">
            <b-form-radio-group
                v-model="selected1"
                :options="options1"
                class="mb-3 input-pad-big"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
            ></b-form-radio-group>

          </div>
        </div>

        <div class="point-container">
          <div class="row">
            <p class="point-number">2. </p>
            <p class="point-name"> Wann ist der Release geplant?</p>
          </div>

          <div class="col">
            <div>
              <b-row>
                <b-col cols="6" class="d-inline-flex justify-content-start align-items-end">
                  <p class="text-white text-left mb-0"> 0 </p></b-col>

                <b-col cols="6" class="d-inline-flex justify-content-end align-items-end">
                  <p class="text-white text-right mb-0"> 56 Wochen </p></b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="mt-5 mb-5" >
                  <vue-slider v-model="value" :min="0" :max="56"
                              :tooltip-formatter="val => val > 1 ? val + ' Wochen' : val + ' Wochen'"
                              :tooltipStyle="{ background: 'transparent'}"
                              :dotStyle="{ background: '#fff' }"
                              :railStyle="{ background: 'rgba(0, 0, 0, 0.25)' }"
                              :processStyle="{ background: 'linear-gradient( 90deg, #3079FF, #00FBAF)' }"></vue-slider>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>

        <div class="point-container">
          <div class="row">
            <p class="point-number">3. </p>
            <p class="point-name"> Zielgruppe</p>
          </div>

          <div class="col">
            <b-form-radio-group
                v-model="selected3"
                :options="options3"
                class="mb-3 input-pad"
                value-field="item"
                text-field="name"
                v-on:input="changeCalView"
                disabled-field="notEnabled"
            ></b-form-radio-group>

          </div>
        </div>

        <div class="point-container">
          <div class="row">
            <p class="point-number">4. </p>
            <p class="point-name">Kurze Beschreibung ihrer App:</p>
          </div>

          <div class="drop-container" id="b2a">
            <b-row>
              <p>Kategorie
              </p><p class="drop-highlighter pl-1 pr-1"> Eigene Mitarbeiter </p>
            </b-row>
            <div>
              <b-form-radio-group
                  v-model="selectedB2B"
                  :options="optionsB2B"
                  class="mb-3 d-grid"
                  value-field="item"
                  html-field="comment"
                  text-field="name"
                  disabled-field="notEnabled"
              ></b-form-radio-group>

            </div>
          </div>

          <div class="drop-container" id="b2b">
            <b-row>
              <p>Kategorie </p><p class="drop-highlighter pl-1 pr-1"> B2B </p>
            </b-row>
            <div>
              <b-form-radio-group
                  v-model="selectedB2B"
                  :options="optionsB2B"
                  class="mb-3 d-grid"
                  value-field="item"
                  html-field="comment"
                  text-field="name"
                  disabled-field="notEnabled"
              ></b-form-radio-group>

            </div>
          </div>
          <div class="drop-container" id="b2c">
            <b-row>
              <p>Kategorie </p><p class="drop-highlighter pl-1 pr-1"> B2C </p>
            </b-row>
            <div>
              <b-form-radio-group

                  v-model="selectedB2C"
                  :options="optionsB2C"
                  class="mb-3 d-grid"
                  value-field="item"
                  html-field="comment"
                  text-field="name"
                  disabled-field="notEnabled"
              ></b-form-radio-group>

            </div>
          </div>

        </div>

        <div class="point-container">
          <div class="row">
            <p class="point-number">5. </p>
            <p class="point-name"> Wichtige Funktionen und Features</p>
          </div>

          <div>
            <b-form-checkbox-group
                v-model="selected5"
                :options="options5"
                class="mb-3 d-grid"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
            ></b-form-checkbox-group>

          </div>
        </div>

        <div class="point-container">
          <div class="row">
            <p class="point-number">6. </p>
            <p class="point-name"> Entwicklungsorganisation</p>
          </div>

          <div class="col">
            <b-form-radio-group
                v-model="selected6"
                :options="options6"
                class="mb-3 input-pad"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
            ></b-form-radio-group>

          </div>
        </div>

        <b-row>
          <b-col class="col-6"></b-col>
          <b-col class="col-6 text-right">
            <b-row class="text-right amount-row">
              <p class="amount-text mt-3 text-right">Kosten - Schritt 1</p>
              <b-button class="amount-button pl-3  ml-3 text-center">€ {{get1cost}}  </b-button>
            </b-row>
          </b-col>
        </b-row>

      </div>
    </div>
    <!--        Second part-->
    <b-row class="cc-point-title-container mt-2">
      <b-col class="col-2 pt-1"><img src="../assets/line.png"></b-col>
      <b-col class="col-lg-6"><h3 class="cc-point-title">Schritt 2 - Marketing und Vertrieb</h3></b-col>
    </b-row>
    <div class="page-paddings">
      <div class="cc-questions-container">


        <div class="point-container">
          <div class="row">
            <p class="point-number">7. </p>
            <p class="point-name"> Umsatzstrategie</p>
          </div>

          <div class="col">
            <b-form-radio-group
                v-model="selected7"
                :options="options7"
                class="mb-3 input-pad-big"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
            ></b-form-radio-group>

          </div>
        </div>

        <div class="point-container">
          <div class="row">
            <p class="point-number">8. </p>
            <p class="point-name"> Eigenes Bezahlsystem innerhalb der App?</p>
          </div>

          <div class="col">
            <b-form-radio-group
                v-model="selected8"
                :options="options8"
                class="mb-3 input-pad-big"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
            ></b-form-radio-group>

          </div>


        </div>


        <div class="point-container">
          <div class="row">
            <p class="point-number">9. </p>
            <p class="point-name"> Wie soll Ihre App verbreitet werden?</p>
          </div>

          <div class="col">
            <b-form-radio-group
                v-model="selected9"
                :options="options9"
                class="mb-3 input-pad-big"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
            ></b-form-radio-group>

          </div>
        </div>

        <b-row>
          <b-col class="col-6"></b-col>
          <b-col class="col-6 text-right">
            <b-row class="text-right amount-row">
              <p class="amount-text mt-3 text-right">Kosten - Schritt 2</p>
              <b-button class="amount-button pl-3  ml-3 text-center">€  {{get2cost}}  </b-button>
            </b-row>
          </b-col>
        </b-row>

      </div>
    </div>
    <!--        ТРЕТЬЯ ЧАСТЬ-->
    <b-row class="cc-point-title-container mt-2">
      <b-col class="col-2 pt-1"><img src="../assets/line.png"></b-col>
      <b-col class="col-lg-7"><h3 class="cc-point-title">Schritt 3 - Technische Anforderungen</h3></b-col>
    </b-row>

    <div class="page-paddings">
      <div class="cc-questions-container">

        <div class="point-container">
          <div class="row">
            <p class="point-number">10. </p>
            <p class="point-name"> Auf welchen Plattformen soll Ihre App erscheinen?</p>
          </div>

          <div class="col">
            <b-form-checkbox-group
                v-model="selected10"
                :options="options10"
                class="mb-3 input-pad-big"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
            ></b-form-checkbox-group>

          </div>
        </div>

        <div class="point-container">
          <div class="row">
            <p class="point-number">11. </p>
            <p class="point-name"> Auf welchen Endgeräten soll Ihre App erscheinen?</p>
          </div>

          <div class="col">
            <b-form-checkbox-group
                v-model="selected11"
                :options="options11"
                class="mb-3 input-pad-big"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
            ></b-form-checkbox-group>

          </div>
        </div>

        <div class="point-container">
          <div class="row">
            <p class="point-number">12. </p>
            <p class="point-name">In wie vielen Sprachen soll Ihre App erscheinen?</p>
          </div>

          <div class="col">
            <b-form-radio-group
                v-model="selected12"
                :options="options12"
                class="mb-3 input-pad-big"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
            ></b-form-radio-group>
          </div>
        </div>

        <div class="point-container">
          <div class="point-container">
            <div class="row">
              <p class="point-number">13. </p>
              <p class="point-name"> Offline-Funktionsfähigkeit:</p>
            </div>

            <div class="col">
              <b-form-radio-group
                  v-model="selected13"
                  :options="options13"
                  class="mb-3 input-pad-big"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
              ></b-form-radio-group>

            </div>
          </div>

          <div class="point-container">
            <div class="row">
              <p class="point-number">14. </p>
              <p class="point-name"> Genutzte Hardware-Funktionen:</p>
            </div>

            <div>
              <b-form-checkbox-group
                  v-model="selected14"
                  :options="options14"
                  class="mb-3 d-grid-40"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
              ></b-form-checkbox-group>
            </div>
          </div>

          <div class="point-container">
            <div class="row">
              <p class="point-number">15. </p>
              <p class="point-name"> Eigenständige Content-Verwaltung:</p>
            </div>

            <div class="col">
              <b-form-radio-group
                  v-model="selected15"
                  :options="options15"
                  class="mb-3 input-pad-big"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
              ></b-form-radio-group>
            </div>
          </div>
          <b-row>
            <b-col class="col-6"></b-col>
            <b-col class="col-6 text-right">
              <b-row class="text-right amount-row">
                <p class="amount-text mt-3 text-right">Kosten - Schritt 3</p>
                <b-button class="amount-button pl-3  ml-3 text-center">€  {{get3cost}}  </b-button>
              </b-row>
            </b-col>
          </b-row>

        </div>
      </div>

      <!--final count-->

      <div>
        <div class="">
          <b-row class="cc-point-title-container mb-5">
            <b-col class="col-lg-8"><h3 class="cc-point-title">Wie viel kostet eine App? </h3></b-col>
          </b-row>

          <b-row class="pt-2">
            <b-col class="col-6"><p class="semi-final-amount">Allgemeine Informationen </p></b-col>
            <b-col class="col-6"><p class="semi-final-amount text-right pr-3">€ {{get1cost}} </p></b-col>
            <b-col class="col-12"><hr class="w-100 "></b-col>
          </b-row>


          <b-row class="pt-2">
            <b-col class="col-6"><p class="semi-final-amount">Marketing und Vertrieb </p></b-col>
            <b-col class="col-6"><p class="semi-final-amount text-right pr-3">€  {{get2cost}} </p></b-col>
            <b-col class="col-12"><hr class="w-100 "></b-col>
          </b-row>

          <b-row class="pt-2">
            <b-col class="col-6"><p class="semi-final-amount">Technische Anforderungen </p></b-col>
            <b-col class="col-6"><p class="semi-final-amount text-right pr-3">€  {{get3cost}} </p></b-col>
            <b-col class="col-12"><hr class="w-100 "></b-col>
          </b-row>

          <b-row class="pt-2 mb-5">
            <b-col class="col-6"><h2 class="cc-point-title">Gesamtkosten</h2></b-col>
            <b-col class="col-6"><h2 class="cc-point-title text-right">€ {{ get1cost + get2cost + get3cost }}</h2></b-col>

          </b-row>

          <!--        footer elements-->


        </div>
        <div class="mt-5" >
          <b-row class="marketing-component p-5">
            <h3 class="text-white ">Hat Ihnen unser APP-Rechner gefallen? Folgen Sie uns auf LinkedIn!  </h3>
            <b-button target="_blank" href="https://www.linkedin.com/company/north-it-group" class="cc-button text-center mx-auto mt-3">Jetzt Posts liken </b-button>
          </b-row>
        </div>

      </div>

      <div class="mt-16" >
        <b-row class="marketing-component p-5" style="text-transform: uppercase">
          <h3 class="text-white">Hinterlassen Sie uns Ihre E-Mail und wir senden Ihnen kostenlos </h3><p style="visibility: hidden">.</p>
          <h3 class="cc-point-title-last">  unseren App Guide </h3>
          <b-row class="w-100">

            <!--                        <div id="mc_embed_signup" class="w-100">-->
            <!--                            <form action="https://northitgroup.us10.list-manage.com/subscribe/post?u=b88b7f682ba8315a4c9b316d5&amp;id=cd6c3d8bb0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>-->
            <!--                                <div id="mc_embed_signup_scroll" class="text-white w-100">-->

            <!--                                    <div class="mc-field-group">-->
            <!--                                        <label for="mce-EMAIL">Email  <span class="asterisk">*</span>-->
            <!--                                        </label>-->
            <!--                                        <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">-->
            <!--                                    </div>-->
            <!--                                    <div class="mc-field-group ">-->
            <!--                                        <label for="mce-LNAME">Vorname </label>-->
            <!--                                        <input type="text" value="" name="LNAME" class="" id="mce-LNAME">-->
            <!--                                    </div>-->
            <!--                                    <div class="mc-field-group mb-5">-->
            <!--                                        <label for="mce-FNAME">Name </label>-->
            <!--                                        <input type="text" value="" name="FNAME" class="" id="mce-FNAME">-->
            <!--                                    </div>-->
            <!--                                    <div id="mce-responses" class="clear">-->
            <!--                                        <div class="response" id="mce-error-response" style="display:none"></div>-->
            <!--                                        <div class="response" id="mce-success-response" style="display:none"></div>-->
            <!--                                    </div>-->
            <!--                                    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_b88b7f682ba8315a4c9b316d5_cd6c3d8bb0" tabindex="-1" value=""></div>-->
            <!--                                    <div class="clear"><input type="submit" value="App Guide bekommen" name="subscribe" id="mc-embedded-subscribe" class="button cc-button"></div>-->
            <!--                                </div>-->
            <!--                            </form>-->
            <!--                        </div>-->
            <!--End mc_embed_signup-->


            <!--                    вьютифай инпуты-->
            <v-row>
              <v-col cols="12" class="fill-height">
                <v-form @submit.prevent="submit" >
                  <v-card tile flat color="transparent">
                    <v-card-text>
                      <v-row>
                        <v-col cols="4" class="pa-0 ma-0">
                          <p class="p-0">Vorname</p>
                          <v-text-field
                              class="pa-0 ma-0"
                              solo
                              type="text"
                              v-model="form.name"></v-text-field>
                        </v-col>
                        <v-col cols="4" class="pa-0 ma-0">
                          <p class="p-0">Nachname</p>
                          <v-text-field
                              class="pa-0 ma-0"
                              solo
                              type="text"
                              v-model="form.surname"></v-text-field>
                        </v-col>
                        <v-col cols="4" class="pa-0 ma-0">
                          <p class="p-0">Email</p>
                          <v-text-field
                              class="pa-0 ma-0"
                              solo
                              type="text"
                              v-model="form.email"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer/>
                      <v-btn type="submit" :loading="loading" class="button cc-button">App Guide bekommen</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-col>

            </v-row>


          </b-row>
        </b-row>
      </div>
    </div>
    <b-row class="site-footer">
      <b-col cols="12" class="text-center">
        <p>Entwickelt von </p><a href="https://northitgroup.com/" target="_blank"><p class="drop-highlighter pl-1 pr-1"> North IT Group GmbH | Unsere Webseite  </p></a>
      </b-col>
      <b-col class="col-6"><p class="text-right pt-3 pr-4"><router-link to="/Impressum">Impressum</router-link></p></b-col>
      <b-col class="col-6"><p class="text-left pt-3 pl-4"><router-link to="/Datenschutz">Datenschutz</router-link></p></b-col>
    </b-row>
  </div>


</template>

<script>

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/material.css'


export default {
  components: {
    VueSlider
  },
  data() {
    return {
      form: {
        name: null,
        surname: null,
        email: null
      },
      loading: false,
      Cost2: '',
      text1: '',
      text2: '',
      formatter: '',
      // total1: 0,
      total2: 0,
      total3: 0,
      value: 8,
      selected1: '',
      selected2: '',
      selected3: '',
      selectedB2B: '',
      selectedB2C: '',
      selected5: '',
      selected6: '',
      selected7: '',
      selected8: '',
      selected9: '',
      selected10: '',
      selected11: '',
      selected12: '',
      selected13: '',
      selected14: '',
      selected15: '',
      result1: '',
      options1: [
        { item: 'A', name: 'Nativ' },
        { item: 'B', name: 'Hybrid' },
        { item: 'C', name: 'Web-App' },
        { item: 'D', name: 'Mobile Webseite' },
      ],
      options2: [
        { item: 'A', name: 'Ja', },
        { item: 'B', name: 'Nein', }
      ],
      options3: [
        { item: 'A', name: 'Eigene Mitarbeiter' },
        { item: 'B', name: 'B2B' },
        { item: 'C', name: 'B2C' }
      ],
      optionsB2B: [
        { item: 'A', comment: '<p class="b-hover">Customer Relation Management<span data-comment class="comment-info">info</span></p>' },
        { item: 'B', comment: '<p class="b-hover">Mitarbeiter Weiterbildung<span data-comment class="comment-info">info</span></p>' },
        { item: 'C', comment: '<p class="b-hover">Weiterbildung allgemein<span data-comment class="comment-info">info</span></p>' },
        { item: 'D', comment: '<p class="b-hover">Finanzmanagement <span data-comment class="comment-info">info</span></p>' },
        { item: 'E', comment: '<p class="b-hover">Task Manager <span data-comment class="comment-info">info</span></p>' },
        { item: 'F', comment: '<p class="b-hover">Messenger <span data-comment class="comment-info">info</span></p>' },
        { item: 'H', comment: '<p class="b-hover">Unternehmenskommunikation <span data-comment class="comment-info">info</span></p>' },
        { item: 'J', comment: '<p class="b-hover">Konferenz-App<span data-comment class="comment-info">info</span></p>' },
        { item: 'K', comment: '<p class="b-hover">Notizverwaltung<span data-comment class="comment-info">info</span></p>' },
        { item: 'O', comment: '<p class="b-hover">E-Mail-Anwendungen <span data-comment class="comment-info">info</span></p>' },
        { item: 'M', comment: '<p class="b-hover">Scan-App<span data-comment class="comment-info">info</span></p>' },
        { item: 'N', comment: '<p class="b-hover">Nachrichten <span data-comment class="comment-info">info</span></p>' },
        { item: 'S', comment: '<p class="b-hover">Remote Access Service<span data-comment class="comment-info">info</span></p>' },
        { item: 'T', comment: '<p class="b-hover">Designer-App <span data-comment class="comment-info">info</span></p>' },
        { item: 'R', comment: '<p class="b-hover">Reservation-App <span data-comment class="comment-info">info</span></p>' },
        { item: 'Z', comment: '<p class="b-hover">Work-Safety and Security-App<span data-comment class="comment-info">info</span></p>' },
        { item: 'X', comment: '<p class="b-hover">Online Shop <span data-comment class="comment-info">info</span></p>' },
        { item: 'Y', comment: '<p class="b-hover">Andere <span data-comment class="comment-info">info</span></p>' }
      ],
      optionsB2C: [
        { item: 'A', comment: '<p class="b-hover" data-id>Spiele <span data-comment class="comment-info">Abenteuer, Action, Arcade, Brettspiele, Gelegenheitsspiele, Kartenspiele, Kasino, Lernspiele, Musik, Puzzles, Rennsport, Rollenspiele, Simulation, Sportspiele, Strategie, Quizspiele, Worträtsel</span></p>' },
        { item: 'B', comment: '<p class="b-hover" data-id>Kunst & Design <span data-comment class="comment-info">Zeichenblöcke, Zeichenbedarf, Zubehör für Kunst & Design, Malbücher</span></p>' },
        { item: 'C', comment: '<p class="b-hover" data-id>Autos & Fahrzeuge <span data-comment class="comment-info">Autokauf, Autoversicherung, Preisvergleich von Autos, Fahrsicherheit, Autobewertungen und -Neuigkeiten</span></p>' },
        { item: 'D', comment: '<p class="b-hover" data-id>Schönheitspflege <span data-comment class="comment-info">Make-Up-Anleitungen, Styling-Tools, Frisuren, Schönheitsprodukte, Make-Up-Simulatoren</span></p>' },
        { item: 'E', comment: '<p class="b-hover" data-id>Bücher & Nachschlagewerke <span data-comment class="comment-info">E-Book-Reader, Nachschlagewerke, Textbücher, Wörterbücher, Thesauren, Wikis</span></p>' },
        { item: 'F', comment: '<p class="b-hover" data-id>Büro <span data-comment class="comment-info">Bearbeiten und Lesen von Dokumenten, Paketverfolgung, Remote Desktop, E-Mail-Verwaltung, Stellensuche</span></p>' },
        { item: 'H', comment: '<p class="b-hover" data-id>Comics <span data-comment class="comment-info">Comic-Player, Comic-Titel</span></p>' },
        { item: 'J', comment: '<p class="b-hover" data-id>Kommunikation <span data-comment class="comment-info">SMS/MMS, Chat/IM, Telefonanwendungen, Adressbücher, Browser, Anrufverwaltung</span></p>' },
        { item: 'K', comment: '<p class="b-hover" data-id>Verabredung <span data-comment class="comment-info">Partnerzuordnung, Kennenlernen, Beziehungen aufbauen, neue Leute kennenlernen, die große Liebe finden</span></p>' },
        { item: 'O', comment: '<p class="b-hover" data-id>Bildung <span data-comment class="comment-info">Prüfungsvorbereitung, Lernhilfen, Vokabeln, Lernspiele, Sprachtrainer</span></p>' },
        { item: 'M', comment: '<p class="b-hover" data-id>Unterhaltung <span data-comment class="comment-info">Videos streamen, Filme, Serien, interaktive Unterhaltung</span></p>' },
        { item: 'N', comment: '<p class="b-hover" data-id>Events <span data-comment class="comment-info">Konzerttickets, Eintrittskarten für Sportveranstaltungen, Weiterverkäufe von Tickets und Kinokarten</span></p>' },
        { item: 'S', comment: '<p class="b-hover" data-id>Finanzen <span data-comment class="comment-info">Bankgeschäfte, Bezahlung, Geldautomatensuche, Finanznachrichten, Versicherungen, Steuern, Aktienhandel, Trinkgeldrechner</span></p>' },
        { item: 'T', comment: '<p class="b-hover" data-id>Essen & Trinken <span data-comment class="comment-info">Rezepte, Restaurants, Essenstipps, Wein entdecken & probieren, Getränkerezepte</span></p>' },
        { item: 'R', comment: '<p class="b-hover" data-id>Gesundheit & Fitness <span data-comment class="comment-info">Persönliche Fitness, Verfolgen von Workout-Erfolgen, Diät- und Ernährungstipps, Gesundheit und Sicherheit</span></p>' },
        { item: 'Z', comment: '<p class="b-hover" data-id>Haus & Heim <span data-comment class="comment-info">Haus- und Wohnungssuche, Renovierungen, Dekoration, Hypotheken, Immobilien</span></p>' },
        { item: 'X', comment: '<p class="b-hover" data-id>Software & Demos <span data-comment class="comment-info">Software-Bibliotheken, technische Demos</span></p>' },
        { item: 'Y', comment: '<p class="b-hover" data-id>Lifestyle <span data-comment class="comment-info">Stilratgeber, Hochzeits- und Partyplanung, Anleitungen</span></p>' },
        { item: 'W', comment: '<p class="b-hover" data-id>Karten & Navigation <span data-comment class="comment-info">Navigationstools, GPS, Karten, Transittools, öffentliche Verkehrsmittel</span></p>' },
        { item: 'V', comment: '<p class="b-hover" data-id>Medizin <span data-comment class="comment-info">Arzneimittelverzeichnisse und klinische Nachschlagewerke, Rechner, Handbücher für Gesundheitsdienstleister, medizinische Fachzeitschriften und Nachrichten</span></p>' },
        { item: 'I', comment: '<p class="b-hover" data-id>Musik & Audio <span data-comment class="comment-info">Musikdienste, Radios, Musikplayer</span></p>' },
        { item: 'PQ', comment: '<p class="b-hover" data-id>Nachrichten & Magazine <span data-comment class="comment-info">Zeitungen, Nachrichtenaggregatoren, Zeitschriften, Blogs</span></p>' },
        { item: 'U', comment: '<p class="b-hover" data-id>Eltern <span data-comment class="comment-info">Schwangerschaft, Säuglingspflege- und Überwachung, Kinderbetreuung</span></p>' },
        { item: 'S', comment: '<p class="b-hover" data-id>Personalisierung <span data-comment class="comment-info">Hintergründe, Live-Hintergründe, Startbildschirm, Sperrbildschirm, Klingeltöne</span></p>' },
        { item: 'P', comment: '<p class="b-hover" data-id>Fotografie <span data-comment class="comment-info">Kameras, Bildbearbeitungstools, Fotoverwaltung und -weitergabe</span></p>' },
        { item: 'Q', comment: '<p class="b-hover" data-id>Effizienz <span data-comment class="comment-info">Notepad, Aufgabenliste, Tastatur, Drucken, Kalender, Sicherung, Rechner, Konvertierung</span></p>' },
        { item: 'L', comment: '<p class="b-hover" data-id>Shopping <span data-comment class="comment-info">Online-Shopping, Auktionen, Gutscheine, Preisvergleich, Einkaufszettel, Produktbewertungen</span></p>' },
        { item: '1', comment: '<p class="b-hover" data-id>Soziale Netzwerke <span data-comment class="comment-info">Soziale Netzwerke, Check-in</span></p>' },
        { item: '2', comment: '<p class="b-hover" data-id>Sport <span data-comment class="comment-info">Sportnachrichten und -kommentare, Spielstand, Fantasieteamzusammenstellung, Spielberichterstattung</span></p>' },
        { item: '3', comment: '<p class="b-hover" data-id>Tools <span data-comment class="comment-info">Tools für Android-Geräte</span></p>' },
        { item: '4', comment: '<p class="b-hover" data-id>Reisen & Lokales <span data-comment class="comment-info">Reisebuchungstools, Fahrgemeinschaften, Taxis, Stadtführer, Informationen zu lokalen Geschäften und Unternehmen, Reiseverwaltungstools, Reisebuchung</span></p>' },
        { item: '5', comment: '<p class="b-hover" data-id>Videoplayer & Editors <span data-comment class="comment-info">Videoplayer, Video-Editor, Medienspeicher</span></p>' },
        { item: '6', comment: '<p class="b-hover" data-id>Wetter <span data-comment class="comment-info"></span></p>' },
        { item: '7', comment: '<p class="b-hover" data-id>Andere <span data-comment class="comment-info"></span></p>' }
      ],
      options5: [
        { item: 'A', name: 'Einfachheit' },
        { item: 'B', name: 'Geschwindigkeit' },
        { item: 'C', name: 'Weniger Tastatureingabe, mehr Bildschirm-Interaktion' },
        { item: 'D', name: 'Überzeugendes Benutzer-Feedback' },
        { item: 'E', name: 'Verschiedene Versionen für verschiedene mobile Geräte' },
        { item: 'F', name: 'Gute Bildauflösung' },
        { item: 'H', name: 'Sicherheit' },
        { item: 'J', name: 'Social Media Networking-Möglichkeiten' },
        { item: 'K', name: 'Suchfunktion in mobiler Anwendung angezeigt' },
        { item: 'O', name: 'Ausdrucksvolles Design, kräftige Farben' }
      ],
      options6: [
        { item: 'A', name: 'Festpreisangebot' },
        { item: 'B', name: 'Agile Entwicklung' },
        { item: 'C', name: 'Outstaffing' }
      ],
      options7: [
        { item: 'A', name: 'Werbung' },
        { item: 'B', name: 'In-App-Käufe' },
        { item: 'C', name: 'kostenpflichtiger Download' },
        { item: 'D', name: 'All4Free' }
      ],
      options8: [
        { item: 'A', name: 'Ja' },
        { item: 'B', name: 'Nein' }
      ],
      options9: [
        { item: 'A', name: 'App Stores' },
        { item: 'B', name: 'Nutzer erhält Link' }

      ],
      options10: [
        { item: 'A', name: 'iOS' },
        { item: 'B', name: 'Android' },
        { item: 'C', name: 'Web' },
      ],
      options11: [
        { item: 'A', name: 'Smartphones' },
        { item: 'B', name: 'Tablets' },
        { item: 'C', name: 'Desktop' },
      ],
      options12: [
        { item: 'A', name: '1' },
        { item: 'B', name: '2' },
        { item: 'C', name: '3' },
        { item: 'D', name: '4' },
        { item: 'E', name: '> 5' }
      ],
      options13: [
        { item: 'A', name: 'Ja' },
        { item: 'B', name: 'Nein' }
      ],
      options14: [
        { item: 'A', name: 'GPS' },
        { item: 'B', name: 'Mikrofon' },
        { item: 'C', name: 'NFC' },
        { item: 'D', name: 'Kamera' },
        { item: 'E', name: 'Bluetooth' },
        { item: 'F', name: 'Gyroskop-Sensor' },
        { item: 'G', name: 'Fingerabdrucksensor' },
        { item: 'H', name: 'Gesichtserkennung' },
        { item: 'I', name: 'Beschleunigungsmesser' },
        { item: 'K', name: 'Näherungssensor' },
        { item: 'L', name: 'Lichtsensor' },
        { item: 'M', name: 'Schrittmesser' },
        { item: 'N', name: 'Pulsmesser' },
        { item: 'O', name: 'Magnetomesser (digitaler Kompass)' }
      ],
      options15: [
        { item: 'A', name: 'Ja' },
        { item: 'B', name: 'Nein' }
      ]
    }
  },
  mounted() {
    localStorage.clear();
    document.querySelectorAll('[data-id]').forEach(item => {
      item.addEventListener('mouseover', () => {
        item.querySelector('[data-comment]').classList.add('visible');
      });
      item.addEventListener('mouseout', () => {
        item.querySelector('[data-comment]').classList.remove('visible');
      })
    })

    this.$root.$on('company-story', (story) => {
      this.title = story.year;
      this.content = story.modal;
      this.$bvModal.show('story-modal')
    });
    if ( !this.$cookies.isKey('_accepted')){
      this.showModal();
    } else if (this.$cookies.get('_accepted')) {
      return;
    } else {
      this.showModal();
    }
  },
  computed: {
    get1cost() {
      // let total1 = 1;
      let total2 = 0.8;
      let total2pred = this.value;
      let total3 = 0;
      let total4 = 1;
      let total51 = 1;
      let total52 = 1;
      let total53 = 1;
      let total54 = 1;
      let total55 = 1;
      let total56 = 1;
      let total57 = 1;
      let total58 = 1;
      let total59 = 1;
      let total510 = 1;
      let total5 = 0;
      let total6 = 1;




      if (this.selected1 === 'A') {
        localStorage.setItem('total1', 1.5);
      } else if ( this.selected1 === 'B') {
        localStorage.setItem('total1', 1);
      } else if ( this.selected1 === 'C') {
        localStorage.setItem('total1', 0.8);
      } else if ( this.selected1 === 'D') {
        localStorage.setItem('total1', 0.5);
      }



      if (this.selected3 === 'A') {
        total3 = 0.9;
      } else if ( this.selected3 === 'B') {
        total3 = 1.1;
      } else if ( this.selected3 === 'C') {
        total3 = 1.2;
      }

      if (this.selectedB2B === 'A') {
        total4 = 16;
      } else if ( this.selectedB2B === 'B') {
        total4 = 16;
      } else if ( this.selectedB2B === 'C') {
        total4 = 16;
      } else if ( this.selectedB2B === 'D') {
        total4 = 28;
      } else if ( this.selectedB2B === 'E') {
        total4 = 8;
      } else if ( this.selectedB2B === 'F') {
        total4 = 8;
      } else if ( this.selectedB2B === 'H') {
        total4 = 12;
      } else if ( this.selectedB2B === 'J') {
        total4 = 16;
      } else if ( this.selectedB2B === 'K') {
        total4 = 8;
      } else if ( this.selectedB2B === 'O') {
        total4 = 12;
      } else if ( this.selectedB2B === 'M') {
        total4 = 24;
      } else if ( this.selectedB2B === 'N') {
        total4 = 24;
      } else if ( this.selectedB2B === 'S') {
        total4 = 10;
      } else if ( this.selectedB2B === 'T') {
        total4 = 24;
      } else if ( this.selectedB2B === 'R') {
        total4 = 36;
      } else if ( this.selectedB2B === 'Z') {
        total4 = 9;
      } else if ( this.selectedB2B === 'X') {
        total4 = 16;
      } else if ( this.selectedB2B === 'Y') {
        total4 = 4;
      }


      if (this.selectedB2C === 'A') {
        total4 = 16;
      } else if ( this.selectedB2C === 'B') {
        total4 = 12;
      } else if ( this.selectedB2C === 'C') {
        total4 = 12;
      }else if ( this.selectedB2C === 'D') {
        total4 = 12;
      }else if ( this.selectedB2C === 'E') {
        total4 = 16;
      }else if ( this.selectedB2C === 'F') {
        total4 = 16;
      }else if ( this.selectedB2C === 'H') {
        total4 = 8;
      }else if ( this.selectedB2C === 'J') {
        total4 = 16;
      }else if ( this.selectedB2C === 'K') {
        total4 = 20;
      }else if ( this.selectedB2C === 'O') {
        total4 = 24;
      }else if ( this.selectedB2C === 'M') {
        total4 = 8;
      }else if ( this.selectedB2C === 'N') {
        total4 = 24;
      }else if ( this.selectedB2C === 'S') {
        total4 = 12;
      }else if ( this.selectedB2C === 'T') {
        total4 = 12;
      }else if ( this.selectedB2C === 'R') {
        total4 = 12;
      }else if ( this.selectedB2C === 'Z') {
        total4 = 12;
      }else if ( this.selectedB2C === 'X') {
        total4 = 12;
      }else if ( this.selectedB2C === 'Y') {
        total4 = 20;
      }else if ( this.selectedB2C === 'W') {
        total4 = 16;
      }else if ( this.selectedB2C === 'V') {
        total4 = 24;
      }else if ( this.selectedB2C === 'I') {
        total4 = 10;
      }else if ( this.selectedB2C === 'PQ') {
        total4 = 12;
      }else if ( this.selectedB2C === 'U') {
        total4 = 12;
      }else if ( this.selectedB2C === 'S') {
        total4 = 24;
      }else if ( this.selectedB2C === 'P') {
        total4 = 12;
      }else if ( this.selectedB2C === 'Q') {
        total4 = 10;
      }else if ( this.selectedB2C === 'L') {
        total4 = 16;
      }else if ( this.selectedB2C === '1') {
        total4 = 12;
      }else if ( this.selectedB2C === '2') {
        total4 = 16;
      }else if ( this.selectedB2C === '3') {
        total4 = 12;
      }else if ( this.selectedB2C === '4') {
        total4 = 12;
      }else if ( this.selectedB2C === '5') {
        total4 = 2;
      }else if ( this.selectedB2C === '6') {
        total4 = 2;
      } else if ( this.selectedB2C === '7') {
        total4 = 8;
      }




      if (this.selected5.includes('A') ){
        total51 = 1.2;
      }
      if ( this.selected5.includes( 'B') ){
        total52 = 1.2;
      }
      if ( this.selected5.includes( 'C') ){
        total53 = 1.2;
      }
      if ( this.selected5.includes( 'D') ){
        total54 = 1.2;
      }
      if ( this.selected5.includes( 'E') ){
        total55 = 1.2;
      }
      if ( this.selected5.includes( 'F') ){
        total56 = 1.2;
      }
      if ( this.selected5.includes( 'H') ){
        total57 = 1.5;
      }
      if ( this.selected5.includes( 'J') ){
        total58 = 1.1;
      }
      if ( this.selected5.includes( 'K') ){
        total59 = 1.1;
      }
      if ( this.selected5.includes( 'O') ){
        total510 = 1;
      }
      this.selected5 ? total5 =  total51 * total52 * total53 * total54 * total55 * total56 * total57 * total58 * total59 * total510 : 0;

      if (this.selected6 === 'A') {
        total6 = 1;
      } else if ( this.selected6 === 'B') {
        total6 = 1.5;
      } else if ( this.selected6 === 'C') {
        total6 = 0.75;
      }
      total2 = this.isZero(total4 / this.isZero(total2pred))

      if (total2 <= 0.8) {
        total2 = 0.8
      }
      let get1cost = this.isZero(localStorage.getItem('total1')) * Math.round(1500 * (2 + ((  this.isZero(total3) * this.isZero(total4) * total2) + total5)) * total6);
      console.log(total2)
      return Math.round(get1cost);
    },
    get2cost () {
      // let total1 = 1;
      let total7 = 0;
      let total8 = 0;
      let total9 = 0;

      if (this.selected1 === 'A') {
        localStorage.setItem('total1', 1.5);
      } else if ( this.selected1 === 'B') {
        localStorage.setItem('total1', 1);
      } else if ( this.selected1 === 'C') {
        localStorage.setItem('total1', 0.8);
      } else if ( this.selected1 === 'D') {
        localStorage.setItem('total1', 0.5);
      }

      if (this.selected7 === 'A') {
        total7 = 1.1;
      } else if ( this.selected7 === 'B') {
        total7 = 1.2;
      } else if ( this.selected7 === 'C') {
        total7 = 1.1;
      } else if ( this.selected7 === 'D') {
        total7 = 0;
      }

      if (this.selected8 === 'A') {
        total8 = 1.2;
      } else if ( this.selected8 === 'B') {
        total8 = 0;
      }

      if (this.selected9 === 'A') {
        total9 = 1.1;
      } else if ( this.selected9 === 'B') {
        total9 = 0;
      }

      let get2cost = this.isZero(localStorage.getItem('total1')) * Math.round(1500 * (total7 + total8 + total9));
      return Math.round(get2cost);
    },
    get3cost () {
      let total10 = 1;
      let total11 = 1;
      let total12 = 0;
      let total13 = 0;
      let total14 = 0;
      let total15 = 0;
      let total141 = 1;
      let total142 = 1;
      let total143 = 1;
      let total144 = 1;
      let total145 = 1;
      let total146 = 1;
      let total147 = 1;
      let total148 = 1;
      let total149 = 1;
      let total1410 = 1;
      let total1411 = 1;
      let total1412 = 1;
      let total1413 = 1;
      let total1414 = 1;


      if (this.selected1 === 'A') {
        localStorage.setItem('total1', 1.5);
      } else if ( this.selected1 === 'B') {
        localStorage.setItem('total1', 1);
      } else if ( this.selected1 === 'C') {
        localStorage.setItem('total1', 0.8);
      } else if ( this.selected1 === 'D') {
        localStorage.setItem('total1', 0.5);
      }

      if (this.selected10.length === 1 ){
        total10 = 1;
      }
      if (this.selected10.length > 1 ){
        total10 = 1.5;
      }



      if (this.selected11.length === 1 ){
        total11 = 1;
      }
      if (this.selected11.length > 1 ){
        total11 = 1.2;
      }


      if (this.selected12 === 'A') {
        total12 = 0;
      } else if ( this.selected12 === 'B') {
        total12 = 1;
      } else if ( this.selected12 === 'C') {
        total12 = 2;
      } else if ( this.selected12 === 'D') {
        total12 = 2;
      } else if ( this.selected12 === 'E') {
        total12 = 3;
      }




      if (this.selected13 === 'A') {
        total13 = 2;
      } else if ( this.selected13 === 'B') {
        total13 = 0;
      }



      if (this.selected14.includes('A') ){
        total141 = 1.1;
      }
      if ( this.selected14.includes( 'B') ){
        total142 = 1.1;
      }
      if ( this.selected14.includes( 'C') ){
        total143 = 1.1;
      }
      if ( this.selected14.includes( 'D') ){
        total144 = 1.1;
      }
      if ( this.selected14.includes( 'E') ){
        total145 = 1.1;
      }
      if ( this.selected14.includes( 'F') ){
        total146 = 1.1;
      }
      if ( this.selected14.includes( 'G') ){
        total147 = 1.1;
      }
      if ( this.selected14.includes( 'H') ){
        total148 = 1.1;
      }
      if ( this.selected14.includes( 'I') ){
        total149 = 1.1;
      }
      if ( this.selected14.includes( 'K') ){
        total1410 = 1.1;
      }
      if ( this.selected14.includes( 'L') ){
        total1411 = 1.1;
      }
      if ( this.selected14.includes( 'M') ){
        total1412 = 1.1;
      }
      if ( this.selected14.includes( 'N') ){
        total1413 = 1.1;
      }
      if ( this.selected14.includes( 'O') ){
        total1414 = 1.1;
      }
      this.selected14 ? total14 =  total141 * total142 * total143 * total144 * total145 * total146 * total147 * total148 * total149 * total1410 * total1411 * total1412 * total1413 * total1414 : 0;

      if (this.selected15 === 'A') {
        total15 = 4;
      } else if ( this.selected15 === 'B') {
        total15 = 0;
      }

      let get3cost = this.isZero(localStorage.getItem('total1')) * (1500 * (this.isZero(total12 + total13 + total14)) * this.isZero(total10) * this.isZero(total11) + 1500 * total15);
      return Math.round(get3cost);
    }
  },
  methods: {

    submit () {
      this.loading = '#28a745';
      this.$httpService.post('api/v2/subscribe', this.form, {
        headers:{
          'X-Subscription-Type': 'appcalc',
          'X-Redirect-URL': window.location.hostname + '/subscribed='
        }
      })
          .then(response => {
            this.$root.$emit('alert', {type: 'success', message: response.data.message, show: true})
            for (let k in this.form){
              /* eslint-disable no-prototype-builtins */
              this.form.hasOwnProperty(k) ? this.form[k] = null : null;
            }
          })
          .finally( () => {
            this.loading = false;
          })
    },
    changeCalView (){
      if ( this.selected3 === 'B') {
        document.getElementById('b2b').classList.add("clickedb2b");
        document.getElementById('b2c').classList.remove("clickedb2b");
        document.getElementById('b2a').classList.remove("clickedb2b");
      } else if (this.selected3 === 'C') {
        document.getElementById('b2c').classList.add("clickedb2b");
        document.getElementById('b2b').classList.remove("clickedb2b");
        document.getElementById('b2a').classList.remove("clickedb2b");
      } else if (this.selected3 === 'A') {
        document.getElementById('b2a').classList.add("clickedb2b");
        document.getElementById('b2b').classList.remove("clickedb2b");
        document.getElementById('b2c').classList.remove("clickedb2b");
      }
    },
    isZero(value) {
      if (value === 0) {
        return 1
      }
      return value;
    },

    showModal() {
      this.$bvModal.show('my-modal')
    },
    acceptCookies() {
      this.$cookies.set('_accepted', true);
      localStorage.setItem('COOKIE', true);
      localStorage.setItem('GA', true);
      this.$bvModal.hide('my-modal')
    }

  }
}
</script>


<style>
  .text-modal {
    color: black!important;
  }
.close {
  display: none!important;
}
.text-modal p{
  color: black!important;
}
.modal-content {
  color: black!important;
}
#mc_embed_signup{background:#474747; clear:left; }
/* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
   We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
#mc_embed_signup input:focus {
  outline: none!important;}
a {
  color: white!important;
}
html {
  scroll-behavior: smooth;
}
body {
  font-family: Poppins!important;
  scroll-behavior: smooth;
}
p {
  color: white;
}
.cc-intro {
  padding-top: 10% !important;
  display: inline-block;
  vertical-align: middle;
}
legend {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  color: #FFFFFF!important;
}
.page-container {

  background-color: #474747;
}
.page-paddings {
  padding-left: 15%;
  padding-right: 15%;
}
.page-paddings-left {
  padding-left: 15%;
}

.cc-button {
  background: #00FBAF!important;
  box-shadow: -10px -10px 25px rgba(0, 251, 175, 0.1), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
  padding-right: 25px!important;
  padding-left: 25px!important;
  border-radius: 50px!important;
  font-family: Poppins;
  font-style: normal;
  font-weight: 700!important;
  font-size: 24px;
  line-height: 133%;
  color: #474747!important;
}
.entry-tittle-main {
  width: 100%;
  background: linear-gradient( 90deg, #3079FF, #00FBAF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #0B2349;
  font-size: 4rem;
}
.cc-point-title {
  width: 100%;
  background: linear-gradient( 90deg, #3079FF, #00FBAF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #0B2349;
}
.cc-point-title-last {
  background: linear-gradient( 270deg, #3079FF, #00FBAF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #0B2349;
}

.row {
  margin-left: 0!important;
  margin-right: 0!important;
}
span {
  color: white;
}
.point-number {
  font-size: 28px;
  line-height: 133%;
  color: #3079FF;
}

.point-container {
  padding-top: 10px;
  padding-bottom: 35px;
}
.point-name {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 133%;
  color: #FFFFFF;
  padding-top: 4px;
  padding-left: 10px;
}

.cc-questions-container {
  box-shadow: -10px -10px 25px rgba(255, 255, 255, 0.09), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
  border-radius: 45px;
  padding: 5%;
  margin-top: 3%;
  margin-bottom: 8%;
}

.amount-text {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 133%;
  color: #FFFFFF;
  vertical-align: middle;
}

.amount-button {
  background: #474747!important;
  box-shadow: -10px -10px 25px rgba(255, 255, 255, 0.1), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
  border-radius: 50px!important;
  width: 200px;
  font-family: Poppins;
  font-style: normal;
  font-weight:600!important;
  font-size: 24px!important;
  line-height: 132%;
  color: #00FBAF!important;
}
.amount-row {
  display: inline-flex;
}
hr {
  background: linear-gradient( 90deg, #3079FF, #00FBAF)!important;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  height: 0.1rem!important;
  display: block;
  width: 100%!important;
}
.semi-final-amount {
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 133%;
  color: #FFFFFF;
}
.marketing-component {
  box-shadow: -10px -10px 25px rgba(0, 251, 175, 0.1), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
  border-radius: 45px;
}
.site-footer {
  background: #323232;
  padding: 20px;
  margin-top: 50px;
}

.my-buttons .active {
  color: #fff !important;
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}
input {
  /*background: linear-gradient( 90deg, #3079FF, #00FBAF)!important;*/
}
.d-grid {
  display: grid!important;
  padding-left: 33px;
}

.d-grid-40 {
  display: grid!important;
  padding-left: 40px;
}
.input-pad {
  padding-left: 17px;
}

.input-pad-big {
  padding-left: 25px;
}
input {
  background-color: #474747;
  /*border: #adb5bd solid 1px;*/
  box-shadow: inset 0px 4px 15px rgba(0, 0, 0, 0.4) !important;
  border: none!important;
  color: white!important;
}

.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background: #474747!important;
  box-shadow: inset 0px 4px 15px rgba(0, 0, 0, 0.4)!important;
  border: none!important;
}

.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: no-repeat 50% / 50% 50%;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("../assets/chech.png") !important;
  width: 35px!important;
  height: 35px!important;
  left: -31px!important;
  top: -9px!important;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("../assets/radio.png") !important;
}

.custom-range::-webkit-slider-thumb {
  background: transparent!important;
  background-color: transparent!important;
  width: 1rem!important;
  height: 1rem!important;
  margin-top: -0.25rem;
  background-image: url("../assets/radio.png") !important;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: none!important;
  transition:none!important;
  -webkit-appearance: none;
  appearance: none;
}
.drop-highlighter {
  color: #00FBAF;
}
.drop-container {
  display: none;
}
.clickedb2b {
  display: block!important;
}
#range-2 {
  background-color: transparent!important;
  box-shadow: none !important;
}
.comment-info {
  display: inline-block;
  visibility: hidden;
  transition: visibility .3s ease-in-out;
  position: absolute;
  top: -50%;
  background: #474747;
  box-shadow: -15px -15px 35px rgba(255, 255, 255, 0.03), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;;
  border-radius: 30px;
  padding: 35px;
  width: 40vw;
  z-index: 200;
}

.comment-info.visible {
  visibility: visible;
}

.b-hover:hover {
  color: #00FBAF;
}
.form-control  {
  background: #474747!important;
}

.vue-slider-dot-tooltip-text {
  color: #00FBAF!important;
  font-size: 1.4rem!important;
}
.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: transparent!important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none!important;
}
.v-input__slot {
  padding-left: 0!important;
  margin-left: 0!important;
}
.v-card__text {
  padding: 0!important;
  margin: 0!important;
}

.v-text-field__slot input[type="text"] {
  padding-left: .375rem!important;
}

</style>
